export enum Role {
    None = -1,
    Administrator = 0,
    ReadOnly = 1,
    Planner = 2,
    Chauffeur = 3,
    Client = 4,
    OrganizationManager = 5,
    ExternalUser = 6
}

export const roles: Map<string, Role> = new Map<string, Role>([
    ["Administrator", Role.Administrator],
    ["ReadOnly", Role.ReadOnly],
    ["Planner", Role.Planner],
    ["Chauffeur", Role.Chauffeur],
    ["Client", Role.Client],
    ["OrganizationManager", Role.OrganizationManager],
    ["ExternalUser", Role.ExternalUser]
]);

export const RoleOptions = [
    { label: "core.roles.administrator", value: Role.Administrator, disabled: true },
    { label: "core.roles.read_only", value: Role.ReadOnly },
    { label: "core.roles.planner", value: Role.Planner },
    { label: "core.roles.chauffeur", value: Role.Chauffeur },
    { label: "core.roles.client", value: Role.Client },
    { label: "core.roles.organization_manager", value: Role.OrganizationManager },
    { label: "core.roles.external_user", value: Role.ExternalUser }
];
